import { render, staticRenderFns } from "./ResultBody.vue?vue&type=template&id=e5282f7a&scoped=true&"
import script from "./ResultBody.vue?vue&type=script&lang=js&"
export * from "./ResultBody.vue?vue&type=script&lang=js&"
import style0 from "./ResultBody.vue?vue&type=style&index=0&id=e5282f7a&scoped=true&lang=css&"
import style1 from "./ResultBody.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5282f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTab,VTabItem,VTabs})
